import * as React from 'react';
import {
    Breakpoints,
    CTA,
    styled,
    ThemeProvider
} from '@volkswagen-onehub/components-core';
import {LinkExternal, OpenInLayer} from '@volkswagen-onehub/icons-core';

import {BaseCmsLinkProps, useCmsLink} from '../../../components/links/CmsLink';
import {isExternalLink} from '../../../utils/link/isExternalLink';

const StyledFlexWrapper = styled.div`
    position: absolute;
    display: flex;
    width: 100%;
    height: 1px;
    justify-content: end;
    top: 0;
    z-index: 1;
    isolation: isolate;
`;
const StyledRoundWrapper = styled.div`
    border-radius: 50%;
    ${({theme: {size}}) => {
        const {static150, static250, static350, static400, static500} = size;

        return `
            height: ${static400};
            margin-inline-end: ${static150};
            margin-top: ${static150};
            width: ${static400};

            a[class^="StyledButton"] {
                height: ${static400};
                min-height: ${static400};
                min-width: ${static400};
                width: ${static400};

                svg {
                        max-height: ${static250};
                        max-width: ${static250};
                    }
            }

            @media (min-width: ${Breakpoints.b960}px) {
                height: ${static500};
                margin-inline-end: ${static250};
                margin-top: ${static250};
                width: ${static500};

                a[class^="StyledButton"] {
                    height: 100%;
                    min-height: ${static500};
                    min-width: ${static500};
                    width: 100%;

                    svg {
                        min-height: ${static350};
                        min-width: ${static350};
                    }
                }
            }`;
    }}
`;

export const LayerLinkItem = (props: BaseCmsLinkProps) => {
    const ref = React.useRef(null);
    const [handleClick, href] = useCmsLink(ref, props);

    const isExternalHref = isExternalLink(href);

    const icon = isExternalHref ? (
        <LinkExternal variant="default" />
    ) : (
        <OpenInLayer />
    );

    return (
        <ThemeProvider theme="inverted">
            <StyledFlexWrapper>
                <StyledRoundWrapper>
                    <CTA
                        aria-hidden
                        emphasis="primary"
                        icon={icon}
                        href={href}
                        onClick={handleClick}
                        tabIndex={-1}
                        tag="a"
                        target={props.target}
                    />
                </StyledRoundWrapper>
            </StyledFlexWrapper>
        </ThemeProvider>
    );
};
